import { NotificationManager } from 'react-notifications';
import { NOTIF_SUCCESS, NOTIF_WARNING, NOTIF_ERROR, NOTIFICATION_TIMEOUT, NOTIF_INFO } from './constants';
import 'react-notifications/lib/notifications.css';

export const isStringEmptyOrNull = (value) => {

    return undefined === value || null === value || '' === value.trim();
}

export const SideNotification = (type, message) => {
    switch (type) {
        default:
        case NOTIF_INFO:
            return NotificationManager.info(message, "INFO", NOTIFICATION_TIMEOUT);
        case NOTIF_SUCCESS:
            return NotificationManager.success(message, "SUCCESS", NOTIFICATION_TIMEOUT);
        case NOTIF_WARNING:
            return NotificationManager.warning(message, "WARNING", NOTIFICATION_TIMEOUT);
        case NOTIF_ERROR:
            return NotificationManager.error(message, "ERROR", NOTIFICATION_TIMEOUT);
    }
}

export const isValidImageType = (file) => {
    const acceptedImageTypes = ['image/jpeg', 'image/png'];
    return file && acceptedImageTypes.includes(file['type'])
}

export const recordImageStyle = {
    width: 525,
    height: 225,
    padding: 20,
    borderWidth: "2px",
    borderColor: "#cacaca",
    marginTop: 8
}
export const adsImageStyle = {
    width: 220,
    height: 220,
    padding: 20
}

export const profileImageStyle = {

    width: 200,
    height: 200,
    padding: 20,
    borderWidth: "2px",
    borderColor: "#cacaca",
    margin : "auto",
    marginTop : 15
}

export const editorTextFix = (editorText) => {
    return (editorText)
        .replace(/<ins>/g, "<u>")
        .replace(/<\/ins>/g, "</u>")
        .replace(/<del>/g, "<s>")
        .replace(/<\/del>/g, "</s>")
        .replace(/<em>/g, "<i>")
        .replace(/<\/em>/g, "</i>")
        .replace(/<code>/g, "<tt>")
        .replace(/<\/code>/g, "</tt>")
}